export default function NewGameSetupModal(props) {
  const {
    companyName,
    startCountry,
    countryOptions,
    onCompanyNameChange,
    onStartCountryChange,
    onSubmit,
    canSubmit
  } = props;

  return (
    <div className="setupOverlay">
      <div className="setupModal" role="dialog" aria-modal="true" aria-labelledby="setup-title">
        <div className="setupHeader">
          <div>
            <strong id="setup-title">Založení společnosti</strong>
            <p>Nejdřív vyber název společnosti a startovní stát. Letiště se načtou až potom.</p>
          </div>
        </div>

        <div className="setupBody">
          <label>
            Název společnosti
            <input
              value={companyName}
              onChange={function (event) {
                onCompanyNameChange(event.target.value);
              }}
              placeholder="Např. Sky Morava"
              maxLength={42}
            />
          </label>

          <label>
            Startovní stát
            <select
              value={startCountry}
              onChange={function (event) {
                onStartCountryChange(event.target.value);
              }}
            >
              <option value="">Vyber stát</option>
              {countryOptions.map(function (country) {
                return (
                  <option key={country.code} value={country.code}>
                    {country.name} ({country.airportCount} letišť)
                  </option>
                );
              })}
            </select>
          </label>
        </div>

        <button className="primary" disabled={!canSubmit} onClick={onSubmit}>
          Začít novou hru
        </button>
      </div>
    </div>
  );
}
